import { StarFilledIcon } from '@radix-ui/react-icons'
import {
  FormField,
  FormControl,
  FormLabel,
  Chip,
  FormMessage,
  Switch,
} from '@/components'
import { cn } from '@/lib/utils'
import {
  getFieldDetails,
  BooleanOptions,
  CrawlerAdvancedFields,
  CrawlerFormFields,
} from './CrawlerForm.schema'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

export const FormSwitcGroup: React.FC<{
  arr: Array<CrawlerAdvancedFields | CrawlerFormFields>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: any
  isAdvanced?: boolean
  customClass?: string
}> = ({ arr, control, customClass, isAdvanced }) => {
  const t = useTranslations('crawler.form')
  const fieldDetails = useMemo(() => getFieldDetails(t), [t])

  return arr.map((fieldName) => (
    <FormField
      key={fieldName}
      control={control}
      name={`${isAdvanced ? 'options.' : ''}${fieldName}`}
      render={({ field }) => (
        <div className={cn('w-full py-1', customClass)}>
          <FormControl>
            <FormLabel
              htmlFor={field.name}
              className={cn(
                'font-bold text-md gap-4',
                fieldDetails[fieldName]?.premium
                  ? 'text-yellow-400'
                  : 'text-white',
              )}
            >
              <Switch
                {...field}
                value={!!field.value ? BooleanOptions.yes : BooleanOptions.no}
                disabled={field.disabled || fieldDetails[fieldName]?.disabled}
                defaultChecked={field.value}
                onCheckedChange={field.onChange}
              />
              {fieldDetails[fieldName]?.title}
              {fieldDetails[fieldName]?.premium && (
                <Chip
                  size="xs"
                  icon={<StarFilledIcon className="w-3 h-3 text-yellow-500" />}
                  text="PRO"
                />
              )}
            </FormLabel>
          </FormControl>
          <FormMessage className={'fieldError'} id={field.name} />
          <p className="text-white mt-0 pt-0 pl-12 lg:pr-32 text-md">
            {fieldDetails[fieldName]?.description}
          </p>
        </div>
      )}
    />
  ))
}
